module.exports = __webpack_public_path__ + "img/ESRI.cd964d1b.png";